export class SMReservationSlots {
  slots = [
    {code: '01', count: 0},
    {code: '12', count: 0},
    {code: '23', count: 0},
    {code: '34', count: 0},
    {code: '45', count: 0},
    {code: '56', count: 0},
    {code: '67', count: 0},
    {code: '78', count: 0},
    {code: '89', count: 0},
    {code: '910', count: 0},
    {code: '1011', count: 0},
    {code: '1112', count: 0},
    {code: '1213', count: 0},
    {code: '1314', count: 0},
    {code: '1415', count: 0},
    {code: '1516', count: 0},
    {code: '1617', count: 0},
    {code: '1718', count: 0},
    {code: '1819', count: 0},
    {code: '1920', count: 0},
    {code: '2021', count: 0},
    {code: '2122', count: 0},
    {code: '2223', count: 0},
    {code: '2324', count: 0}
  ];
}
